import {
  collection,
  doc,
  serverTimestamp,
  writeBatch,
} from "firebase/firestore";
import { auth, dbAccounts } from "../../../../backend/firebaseConfig";
import { assertChargeDatesAreOpen } from "../utils/closedChargeMonths";

const collectionRef = collection(dbAccounts, "MonthlyManualPayments");

const auditFields = (fileName) => {
  const user = auth.currentUser;
  return {
    source: "opening_balance_bulk_upload",
    sourceFileName: String(fileName || ""),
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    createdBy: {
      uid: user?.uid || "",
      email: user?.email || "",
      name: user?.displayName || user?.email || "",
    },
  };
};

export const uploadOpeningBalanceRows = async ({ rows, monthKey, fileName }) => {
  if (!Array.isArray(rows) || !rows.length) throw new Error("There are no rows to upload.");
  if (rows.some((row) => !row.mappingTargetId)) {
    throw new Error("Map every row to an adviser or IO introducer before uploading.");
  }
  await assertChargeDatesAreOpen([
    ...rows.map((row) => row.openingBalanceDate),
    ...rows.map((row) => row.advanceDate),
    `${monthKey}-01`,
  ]);

  const batch = writeBatch(dbAccounts);
  let entries = 0;
  rows.forEach((row) => {
    const adviser = {
      adviserEmail: String(row.adviserEmail).trim().toLowerCase(),
      adviserName: String(row.adviserName || "").trim(),
      adviserId: row.adviserId || "",
      brandName: row.brandName || "",
    };
    const mappedRecipient = {
      mappedEntityType: row.mappingTargetType || "adviser",
      mappedEntityId: String(row.mappingTargetId || row.adviserEmail || "").trim(),
      mappedEntityName: String(row.mappingTargetName || row.adviserName || "").trim(),
      ioIntroducerId: row.mappingTargetType === "introducer"
        ? String(row.mappingTargetId || "").trim()
        : null,
    };
    if (row.openingBalance !== null) {
      batch.set(doc(collectionRef), {
        recordType: "opening_balance",
        paymentType: "opening_balance",
        ...adviser,
        ...mappedRecipient,
        date: new Date(`${row.openingBalanceDate}T00:00:00.000Z`).toISOString(),
        paymentMonth: monthKey,
        description: "Opening Balance brought forward",
        openingBalanceAmount: Number(row.openingBalance),
        amountPaid: 0,
        amountDeducted: 0,
        netAmount: 0,
        sourceRowNumber: row.rowNumber,
        sourceName: row.sourceName,
        ...auditFields(fileName),
      });
      entries += 1;
    }
    if (row.advance !== null) {
      batch.set(doc(collectionRef), {
        recordType: "manual_payment",
        paymentType: "advance",
        ...adviser,
        ...mappedRecipient,
        date: new Date(`${row.advanceDate}T00:00:00.000Z`).toISOString(),
        paymentMonth: monthKey,
        description: "Advance",
        amountPaid: Number(row.advance),
        amountDeducted: Number(row.advance),
        netAmount: 0,
        deductionMonth: monthKey,
        notes: "Bulk uploaded September advance",
        sourceRowNumber: row.rowNumber,
        sourceName: row.sourceName,
        ...auditFields(fileName),
      });
      entries += 1;
    }
  });
  await batch.commit();
  return entries;
};
